import React from "react";

function Title(params: {
  children: React.ReactNode;
  text?: "black" | "white";
  heading: "h2" | "h3" | "h4";
}) {
  return (
    <div>
      {params.heading === "h3" ? (
        <h3
          className=" text-[24px] lg:text-[28px] leading-[1.2]
                    font-degular-display-regular line-clamp-3 !no-underline"
          style={{ color: params.text === "black" ? "#000" : "#fff" }}
        >
          {params.children}
        </h3>
      ) : params.heading === "h4" ? (
        <h3
          className=" text-[16px] leading-[1.2] 
                  font-degular-display-regular line-clamp-3 !no-underline"
          style={{ color: params.text === "black" ? "#000" : "#fff" }}
        >
          {params.children}
        </h3>
      ) : (
        <h2
          className=" capitalize text-[40px] lg:text-[48px] font-bold
            tracking-[-0.6px] font-degular-display-semibold leading-none"
          style={{ color: params.text === "black" ? "#000" : "#fff" }}
        >
          {params.children}
        </h2>
      )}
    </div>
  );
}

export default Title;
